import { Navigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useUserLocation from "../hooks/useUserLocation";
import {
  getClubsListPath,
  getCityLabelFromSlug,
  resolveDefaultCityLabel,
} from "../utils/clubPath";

/** /clubs or /clubs?city=Goa → /clubs/Goa */
const ClubsRedirect = () => {
  const [searchParams] = useSearchParams();
  const selectedCity = useSelector((state) => state.citySelector.selectedCity);
  const { locationData } = useUserLocation();

  const queryCity = searchParams.get("city");
  const label = queryCity
    ? getCityLabelFromSlug(queryCity)
    : resolveDefaultCityLabel(selectedCity, locationData?.city);

  return <Navigate to={getClubsListPath(label)} replace />;
};

export default ClubsRedirect;
